import Layout from '@/layout'

const route = {
  path: '/permission',
  component: Layout,
  redirect: '/admin/index',
  alwaysShow: true,
  name: 'Permission',
  meta: {
    title: 'permission',
    icon: 'diy-QrXmGrLi',
    roles: [
      // 'larke-admin.admin.index',
      // 'larke-admin.auth-group.index',
      // 'larke-admin.auth-rule.index',
      // 'larke-admin.log.index'
      'authority_management'
    ]
  },
  children: [
    // 管理员
    {
      path: '/admin/index',
      component: () => import('@/views/admin/index'),
      name: 'Admin',
      meta: {
        title: 'admin',
        icon: 'home',
        roles: [
          'admin.index'
        ]
      }
    },

    // 菜单管理
    {
      path: '/menu/index',
      component: () => import('@/views/menu/index'),
      name: 'Menu',
      meta: {
        title: 'menu',
        icon: 'list',
        roles: [
          'menus.index'
        ]
      }
    },

    // 分组
    {
      path: '/auth/group/index',
      component: () => import('@/views/auth-group/index'),
      name: 'AuthGroup',
      meta: {
        title: 'authGroup',
        icon: 'list',
        roles: [
          /* 'larke-admin.auth-group.index' */
          'groups.index'
        ]
      }
    },
    {
      path: '/auth/group/tree',
      component: () => import('@/views/auth-group/tree'),
      name: 'AuthGroupTree',
      meta: {
        title: 'authGroupTree',
        activeMenu: '/auth/group/index',
        roles: [
          'groups.index'
        ]
      },
      hidden: true
    },

    // 权限
    {
      path: '/auth/rule/index',
      component: () => import('@/views/auth-rule/index'),
      name: 'AuthRule',
      meta: {
        title: 'authRule',
        icon: 'list',
        roles: [
          'rules.index'
        ]
      }
    },
    {
      path: '/auth/rule/tree',
      component: () => import('@/views/auth-rule/tree'),
      name: 'AuthRuleTree',
      meta: {
        title: 'authRuleTree',
        activeMenu: '/auth/rule/index',
        roles: [
          'rules.index'
        ]
      },
      hidden: true
    },

    // 日志
    {
      path: '/adminlog/index',
      component: () => import('@/views/admin-log/index'),
      name: 'AdminLog',
      meta: {
        title: 'adminLog',
        icon: 'list',
        roles: [
          'admin_log.index'
        ]
      }
    }

  ]
}

export default route
